import React from "react";
import { parseGradeOverall, is10Perfect } from "../../utils/utils";

const GradingBadge = ({ grading, size = "medium", onClick }) => {
  const gold = is10Perfect(grading);

  return (
    <div className="row w-100 py-2 font-size-10px m-0">
      <div className="col-12 d-flex justify-content-center align-items-center text-center">
        <div className={`br-50px ${gold ? 'bg-gold-aig-gradient p-2px' : 'bg-aig-gradient p-2px'}`}>
          <div
            className={`d-flex justify-content-center align-items-center text-center p-0 w-100 br-50px bg-white grading-container-${size}`}
            onClick={onClick || undefined}
            style={onClick ? { cursor: 'pointer' } : undefined}
          >
            <span className={`grading-${size} ${gold ? 'text-gold-aig-gradient' : 'text-aig-gradient'}`}>
              {parseGradeOverall(grading, true)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradingBadge;
